import { render, staticRenderFns } from "./form.component.vue?vue&type=template&id=13cef8ee"
import script from "./form.component.js?vue&type=script&lang=js&external"
export * from "./form.component.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports